
import { useState } from 'react';

export const useQuizState = () => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number>(0);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [correctAnswers, setCorrectAnswers] = useState<number>(0);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const resetQuiz = () => {
    setCurrentQuestionIndex(0);
    setSelectedOption(null);
    setSelectedOptions([]);
    setCorrectAnswers(0);
    setIsSubmitting(false);
  };

  return {
    currentQuestionIndex,
    setCurrentQuestionIndex,
    selectedOption,
    setSelectedOption,
    selectedOptions,
    setSelectedOptions,
    correctAnswers,
    setCorrectAnswers,
    isSubmitting,
    setIsSubmitting,
    resetQuiz
  };
};
